import { Box, Grid, Typography } from '@mui/material';

import { FormAutocompleteField, FormNumberField } from '../../../../../common';
import { MEDICAL_DELIVERY_OPTIONS } from '../constants';
import {
  MEDICAL_FIELD_GROUP_SX,
  MEDICAL_INLINE_NUMBER_SX,
  MEDICAL_NUMERIC_GROUP_SX,
} from './styles';

import type { MedicalFieldsProps } from '../types';

export default function BirthInfoFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Child delivery type"
          name="child_delivery_type"
          onChange={saveField}
          options={MEDICAL_DELIVERY_OPTIONS.map((value) => ({ label: value, value }))}
          placeholder="Select type of delivery"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 145px', fontSize: 14 }}>Child’s Gestational age at Birth</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Weeks"
              max={99}
              min={0}
              name="child_gestational_age_weeks"
              onBlur={saveField}
              placeholder="wks"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
            <Typography sx={{ fontSize: 14 }}>weeks .</Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 120px', fontSize: 14 }}>Child’s weight at birth</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Pounds"
              max={99}
              min={0}
              name="child_weight_at_birth_pounds"
              onBlur={saveField}
              placeholder="lbs"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Ounces"
              max={15}
              min={0}
              name="child_weight_at_birth_ounces"
              onBlur={saveField}
              placeholder="oz"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
